import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiStar, FiList, FiArrowLeft } from 'react-icons/fi';

// Servicos
import api from 'services/api';

import { InsercaoItem } from 'pages/Eleicoes/@types';

// Components
import Timeline from 'components/Timeline';
import Widget from 'components/Widget';
import Card from 'components/Card';
import Button from 'components/Button';
import { Container, Header, Tr, Content, TableLinhaRoteiro } from './styles';
import { Scroll, Td } from 'styles/global';

interface LinhaRoteiroItem {
  id: number;
  codmaterial: number;
  separador: boolean;
  cliente: string;
  ippt: string;
  numippt: number;
  titulo: string;
  abrangencia: string;
  programa: ProgramaItem;
  insercao: InsercaoItem[];
  intervaloeleicao?: number;
}
interface ProgramaItem {
  id: number;
  nome: string;
}

export default function LinhasRoteiroEleicao() {
  // react-router-dom
  const navigate = useNavigate();
  /**
   * USE STATE
   */
  const [linhasRoteiro, setLinhasRoteiro] = useState<LinhaRoteiroItem[]>([]);
  const [linhasRoteiroCompleto, setLinhasRoteiroCompleto] = useState<
    LinhaRoteiroItem[]
  >([]);
  const [timelineData, setTimelineData] = useState([]);
  const [nomeRoteiro, setNomeRoteiro] = useState('Roteiro');
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState(false);

  /**
   * USE PARAMS
   */
  const { roteiroId } = useParams<{ roteiroId: string }>();

  /**
   * USE CALLBACK
   */
  const handleWidgetClick = useCallback(
    (filtroPolitico: boolean) => {
      setFiltro(filtroPolitico);
      if (filtroPolitico)
        setLinhasRoteiro(
          linhasRoteiroCompleto.filter(l => l.insercao.length > 0),
        );
      else setLinhasRoteiro(linhasRoteiroCompleto);
    },
    [linhasRoteiroCompleto],
  );

  /**
   * USE EFFECT
   */
  useEffect(() => {
    async function loadRoteiro() {
      setLoading(true);
      try {
        const response = await api.get(`/eleicoes/roteiro/${roteiroId}`);

        if (response.data) {
          setLinhasRoteiro(response.data.linhasroteiro);
          setLinhasRoteiroCompleto(response.data.linhasroteiro);
          setTimelineData(response.data.timeline);
          setNomeRoteiro(response.data.filename);
        }
      } catch (error) {
        toast.error((error as Error).message);
      } finally {
        setLoading(false);
      }
    }

    if (roteiroId) {
      setLoading(true);
      loadRoteiro();
    }
  }, [roteiroId]);

  return (
    <Container>
      <Header>
        <Button size="lg" color="primary" onClick={() => navigate(-1)}>
          VOLTAR
          <FiArrowLeft />
        </Button>
        <Widget
          title="Inserções"
          showLink={false}
          handleClick={() => handleWidgetClick(false)}
          active={!filtro}
          icon={<FiList />}
          color="rede"
          type="mini"
          loading={loading}
          data={linhasRoteiroCompleto.length}
        />
        <Widget
          title="Políticos"
          showLink={false}
          handleClick={() => handleWidgetClick(true)}
          active={filtro}
          color="warn"
          icon={<FiStar />}
          loading={loading}
          type="mini"
          data={linhasRoteiroCompleto.filter(l => l.insercao.length > 0).length}
        />
      </Header>
      <Content>
        <Card>
          <>
            <header>
              <h4>{nomeRoteiro}</h4>
            </header>
            {linhasRoteiro.length > 0 && !loading && (
              <Scroll>
                <TableLinhaRoteiro>
                  <thead>
                    <tr>
                      <th style={{ minWidth: '120px' }}>BL/SQ</th>
                      <th style={{ minWidth: '80px' }}>CM</th>
                      <th>TITULO</th>
                      <th>ABG</th>
                      <th>PROGRAMA</th>
                      <th>INTERVALO</th>
                    </tr>
                  </thead>

                  <tbody>
                    {!!linhasRoteiro &&
                      linhasRoteiro.map((l: LinhaRoteiroItem) => (
                        <Tr intervaloeleicao={l.intervaloeleicao} key={l.id}>
                          {l.insercao && l.insercao.length > 0 ? (
                            <td>{`BL${l.insercao[0].bloco} / SQ${l.insercao[0].sequencia}`}</td>
                          ) : (
                            <td>-</td>
                          )}
                          <td>{l.codmaterial}</td>
                          <Td>
                            {l.titulo}{' '}
                            {l.cliente && <strong>({l.cliente})</strong>}
                          </Td>
                          <td>{l.abrangencia}</td>
                          <td>
                            {l.programa ? l.programa.nome : 'NÃO IDENTIFICADO'}
                          </td>
                          <td>{l.ippt + ' ' + l.numippt}</td>
                        </Tr>
                      ))}
                  </tbody>
                </TableLinhaRoteiro>
              </Scroll>
            )}
          </>
          {linhasRoteiro.length <= 0 && !loading && (
            <p>Nenhuma linha encontrada</p>
          )}
          {loading && <p>Carregando...</p>}
        </Card>
        <Card>
          <Timeline
            data={timelineData}
            height="calc(100vh - 240px)"
            roteiroId={roteiroId}
            layout="2-columns"
            padding="15px 0 0 0"
          />
        </Card>
      </Content>
    </Container>
  );
}
